import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=1f0a4ea9"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=1f0a4ea9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports